import { connect } from 'react-redux';
import Info from './info';
import { closePanel } from '../../actions/panel';
import { removeFromCanvas, updateAttributes } from '../../actions/canvas';
import { addToCart } from '../../actions/cart';
import { workSizeDetails } from '../../selectors/work_sizes';

const mapStateToProps = (state) => {
  const {
    canvas: {
      name, currency
    }
  } = state;

  return {
    worksExtended: workSizeDetails(state),
    name,
    currency
  };
};

export default connect(mapStateToProps, {
  removeFromCanvas, closePanel, addToCart, updateAttributes
})(Info);
